import { useMutation, UseMutationOptions, useQueryClient } from '@tanstack/react-query';
import { QueryKey } from 'common/enums/query-key';
import { AxiosError } from 'axios';
import { BackendError } from 'common/types/errors/backendError';
import { requestBackgroundCheck } from 'services/api/background-check-api.service';
import { ScreeningCheckStatus } from 'common/types/services/api/offers/offer-item-dto.type';
import { notification } from 'services/services';

type Variables = { offerId: string; orderPlanId: string; userId: string; location: string, screeningCheckStatus: ScreeningCheckStatus };

export default function useRequestBackgroundCheck(
  options?: Omit<UseMutationOptions<boolean, AxiosError<BackendError>, Variables, unknown>, 'mutationFn'>,
) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ offerId, orderPlanId, screeningCheckStatus }) => requestBackgroundCheck(offerId, orderPlanId, screeningCheckStatus),
    onError: (e, variables, context) => {
      options?.onError?.(e, variables, context);
    },
    onSuccess: (data, variables, context) => {
      notification.success('Background check has been requested.');
      options?.onSuccess?.(data, variables, context);
    },
    onSettled: (data, error, variables) => {
      queryClient.invalidateQueries({ queryKey: [QueryKey.Offers] });
      queryClient.invalidateQueries({ queryKey: [QueryKey.TenantScreening, 'orders', variables.userId, variables.location] });
      queryClient.refetchQueries({ queryKey: [QueryKey.TenantScreening, 'orders', variables.userId, variables.location] });
      queryClient.invalidateQueries({ queryKey: [QueryKey.ApplicantScreeningReport, variables.userId, variables.offerId] });
    },
    ...options,
  });
}